<script>
export let msg_show;
export let msg_text;
export let msg_type; // error or success
export let show_resend_option;

export let email_to;


import { auth } from 'store/index.js';


import { get } from 'svelte/store';
import { createForm } from 'svelte-forms-lib';
import * as yup from 'yup';
import { navigateTo, Navigate } from 'svelte-router-spa';


const api_url = app_.env.API_URL;
let loading = false;



const { form, errors, state, handleChange, handleSubmit } = createForm({
	initialValues: {
		email: '',
	},
	validationSchema: yup.object().shape({
		email: yup
			.string()
			.trim()
			.email()
			.required(),
	}),
	onSubmit: values => {

		loading = true;

		submitCodeSendNew((values.email).trim()).then(data => {

			msg_type = 'success';
			msg_show = true;

			email_to = values.email;
			show_resend_option = true;

		}).catch(error => {

			msg_type = 'error';
			msg_show = true;

		}).finally(() => {

			loading = false;

		});

	}
});


async function submitCodeSendNew(email) {

	const url = `${api_url}auth/coach/code/send-new/${email}`;

	const resp = await fetch(url, {
		method: 'POST',
	});

	const result = await resp.json();

	if (!resp.ok) {
		msg_text = result.detail;
		throw new Error(result.detail);
	}

	msg_text = result.msg;
	return result;

}


</script>



<style>

#auth-code-send-new-form {

}

</style>


<form id="auth-code-send-new-form" on:submit={handleSubmit}>

	<div class="field">

		<div class="control">

			<input placeholder="Email" class="input" type="text" id="email" name="email" on:change={handleChange} bind:value={$form.email}>

			{#if $errors.email}
				<small>{$errors.email}</small>
			{/if}

		</div>

	</div>

	<div class="field is-grouped">

		<div class="control">

			<button type="submit" class="button is-blue">
				<span>Continue</span>
				<i class="fas fa-circle-notch fa-spin" class:is-hidden={!loading}></i>
			</button>

		</div>

		<div class="control">

			<Navigate to="/login" styles="form-card-link">
				<span>Back to Login</span>
			</Navigate>

		</div>

	</div>

</form>


